import session from './session';

export default {
  post_support_ticket(data) {
    return session.post('/api/support/support_ticket/', data);
  },
};